import React from "react";

// Components
import { AddUser } from "shared/components/user";
import Overlay from "shared/components/overlay/Overlay";
import SlidingPanel from "shared/components/sliding-panel/SlidingPanel";

// Styles
import styles from './AddUser.module.scss';

const AddUserPanel = ({ isActive=false, onAddNewUser, onClose }) => {
    return (
        <div className={ styles.wrapper }>
            <SlidingPanel className={ styles.panel } isActive={ isActive }>
                { <AddUser
                    onClose={ onClose }
                    onAddNewUser={ onAddNewUser } />
                }
            </SlidingPanel>

            <Overlay isActive={ isActive } isContained onClick={ onClose } />
        </div>
    )
}

export default AddUserPanel;
